export const CONSTANTS = {
  phonePattern: /^\(?([2-9][0-9]{2})\)?[-. ]?([2-9](?!11)[0-9]{2})[-. ]?([0-9]{4})$/,
  // Adapted from https://stackoverflow.com/a/1373724 but adds capital letters to the mix.
  emailPattern:
    /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/,
  vinPattern: /^[0-9A-HJ-NPR-Za-hj-npr-z]{8}[0-9Xx][0-9A-HJ-NPR-Za-hj-npr-z]{8}$/,
};
